<template>
  <div>
    <template v-if="institution && !institution.kl_assessment">
      <Page404></Page404>
    </template>
    <div v-else>
      <NavigationBreadcrumb
        :items="breadcrumb_items"
        :sectionId="section_id"
        :showMatterProgram="true"
        :showPdaView="true"
        :showNewFullGradingView="true"
        :showAssessmentStudents="true"
        :showEvaluatorEvaluations="true"
        :showProfessorProgressionReportView="true"
      ></NavigationBreadcrumb>
      <div class="mt-3 mb-2 px-3">
        <template v-if="section && section.egress_profile_matter != null">
          <h4>
            {{
              $t("dashboard.dashboardView.informationOfThe", {
                entity: $getVisibleNames(
                  "mesh.egressprofilematter",
                  false,
                  "Asignatura"
                ),
              })
            }}
          </h4>
          <NewMatterPresentation
            class="mt-3"
            v-if="egress_profile_matter && matter"
            :Matter="egress_profile_matter"
            :oldMatter="matter"
          ></NewMatterPresentation>
        </template>
        <template v-else-if="section && section.matter != null">
          <h4>
            {{
              $t("dashboard.dashboardView.informationOfThe", {
                entity: $getVisibleNames(
                  "teaching.matter",
                  false,
                  "Asignatura Base"
                ),
              })
            }}
          </h4>
          <NewMatterPresentation
            class="mt-3"
            v-if="matter"
            :oldMatter="matter"
          ></NewMatterPresentation>
        </template>
      </div>
      <template v-if="egress_profile_matter">
        <h4>
          {{
            $t("dashboard.dashboardView.informationOfThe", {
              entity: $getVisibleNames("teaching.section", false, "Sección"),
            })
          }}
        </h4>
        <HeaderSection
          class="pt-1 pb-4"
          :Matter="egress_profile_matter"
          :section_id="section_id"
          :allows_crud="false"
        ></HeaderSection
      ></template>
      <h3>{{ $t("dashboard.dashboardView.assessmentReport") }}</h3>
      <AssessmentRangeSection
        v-if="
          egress_profile_matter &&
          matter &&
          section.id &&
          section.egress_profile_matter
        "
        :sections_ids="[section.id]"
        :egress_profile_matter="egress_profile_matter"
      >
      </AssessmentRangeSection>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "AssessmentRangeSectionView",
  components: {
    NewMatterPresentation: () =>
      import(
        "@/components/teaching/MatterProgram/Components/NewMatterPresentation.vue"
      ),
    AssessmentRangeSection: () =>
      import(
        "@/components/reports/TeachingReport/AssessmentRangeSection/AssessmentRangeSection.vue"
      ),
    HeaderSection: () => import("@/components/teaching/Section/HeaderSection"),
    Page404: () => import("@/components/public/Page404"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      section_id: Number(this.$route.params.section_id),
      allows_crud: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      sections: names.SECTIONS,
      egress_profile_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
    }),
    section() {
      return this.sections.find((x) => x.id == this.section_id);
    },
    egress_profile_matter() {
      if (this.section && this.section.egress_profile_matter != null)
        return this.egress_profile_matters.find(
          (x) => x.id == this.section.egress_profile_matter
        );
      else return null;
    },
    matter() {
      if (this.section && this.section.matter != null)
        return this.matters.find((x) => x.id == this.section.matter);
      else if (
        this.egress_profile_matter &&
        this.egress_profile_matter.matter != null
      )
        return this.matters.find(
          (x) => x.id == this.egress_profile_matter.matter
        );
      else return null;
    },
    breadcrumb_items() {
      let breadcrumb = [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
      ];
      // Solo mostrar "Administrar Secciones" si NO es profesor
      if (this.user && !this.user.group_names.includes("PROFESORES")) {
        breadcrumb.push({
          text: this.$getVisibleNames(
            "manual.administrar_seccion",
            true,
            "Administrar Secciones"
          ),
          to: "/section/form",
        });
      }
      breadcrumb.push({
        text: this.$t("dashboard.dashboardView.assessmentReport"),
        dropdownOptions: [
          ...(this.institution && this.institution.internal_use_id == "duoc.cl"
            ? ["showPdaView"]
            : ["showMatterProgram"]),
          "showNewFullGradingView",
          "showAssessmentStudents",
          "showEvaluatorEvaluations",
          "showProfessorProgressionReportView",
        ],
      });
      return breadcrumb;
    },
  },
  methods: {
    pushDashboard() {
      this.$swal
        .fire({
          backdrop: `rgba(0,0,0,0.99)`,
          title: this.$t("evaluations.newEvaluations.accessDenied"),
          text: this.$t("dashboard.dashboardView.noPermissionToViewNextView"),
          type: "warning",
          showConfirmButton: false,
          timer: 5000, // Tiempo del temporizador en milisegundos (5000 ms = 5 segundos)
          timerProgressBar: true,
          willClose: () => {
            this.$router.push({ name: "DashboardView" });
          },
        })
        .then(() => {
          this.$router.push({ name: "DashboardView" });
        });
    },
  },
  watch: {
    section(value) {
      if (
        value != null &&
        this.user &&
        (this.user.group_names.includes("ESTUDIANTES") ||
          (this.user.group_names.includes("PROFESORES") &&
            !value.professors.includes(this.user.id)))
      ) {
        this.pushDashboard();
      }
    },
  },
  mounted() {},
  created() {
    this.$store
      .dispatch(names.FETCH_SECTION, this.section_id)
      .then((section) => {
        if (section.egress_profile_matter != null) {
          this.$store
            .dispatch(
              names.FETCH_EGRESS_PROFILE_MATTER,
              section.egress_profile_matter
            )
            .then((egress_profile_matter) => {
              this.$store.dispatch(
                names.FETCH_MATTER,
                egress_profile_matter.matter
              );
            });
        } else if (section.matter != null) {
          this.$store.dispatch(names.FETCH_MATTER, section.matter);
        }
      });
  },
};
</script>

<style scoped>
</style>

